import { Box, Typography } from "@mui/material";
import { globe } from "../../../../../../icon/globe";
import React from "react";
import { CourseDataInfo } from "../../../../../../types";

interface HeaderPreviewProps {
  courseDetails: CourseDataInfo | undefined;
}

export const CourseHeaderPreview = React.memo(
  ({ courseDetails }: HeaderPreviewProps) => {
    return (
      <Box
        sx={{
          display: "flex",
          padding: "44px 176px 44px 32px",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "24px",
          borderRadius: "8px",
          backgroundColor: "#0573E4",
          //
          "@media (max-width:1000px)": {
            width: "100%",
          },
        }}>
        <Box
          sx={{
            "@media (max-width:1000px)": {
              width: "100%",
            },
          }}>
          <Typography
            sx={{ fontSize: "36px", fontWeight: 800, color: "#fff" }}
            variant="h5">
            {courseDetails?.name || "null"}
          </Typography>
        </Box>
        <Typography sx={{ fontSize: "20px", fontWeight: 400, color: "#fff" }}>
          {courseDetails?.subtitle ? (
            <Typography
              sx={{ fontSize: "20px", fontWeight: 400, color: "#fff" }}>
              {courseDetails.subtitle}
            </Typography>
          ) : (
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: 400,
                color: "rgba(255,255,255,0.28)",
              }}>
              Вы не заполнили описание.
            </Typography>
          )}
        </Typography>
        <Typography>
          <Box>
            <Typography
              sx={{ fontSize: "16px", fontWeight: 400, color: "#fff" }}>
              Автор курса: {courseDetails?.author || "null"}
            </Typography>
          </Box>
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}>
          {globe}
          <Typography sx={{ fontSize: "16px", fontWeight: 800, color: "#fff" }}>
            {courseDetails?.language}
          </Typography>
        </Box>
      </Box>
    );
  }
);
